<template>
  <div class="video-card">
    <div @click="playVideo" class="video-card-header">
      <img v-show="imgLoaded" :src="videoInfo.thumbnailURL" alt="" class="video-card-img" @load="onImgLoad">
      <b-skeleton-img v-if="!imgLoaded" no-aspect width="100%" height="160px"></b-skeleton-img>
      <div class="header-pills">
        <div v-if="videoInfo.newBanner" class="event-pill">¡Nuevo!</div>
      </div>
      <div class="play-button-wrapper">
        <i class="fa fa-play play-button"></i>
      </div>
    </div>
    <div class="video-card-content">
      <div class="top-info">
        <div>{{ videoInfo.category }}</div>
        <div>{{ videoInfo.uploadDate}}</div>
      </div>
      <div class="center-info">
        <h4>{{ videoInfo.title }}</h4>
      </div>
      <div class="bottom-info">
        <div class="bottom-info-item">{{ videoInfo.difficulty }}</div>
        <div class="bottom-info-item">{{ videoInfo.length }}</div>
      </div>
      <div v-if="videoInfo.tools" class="bottom-info-bells"><i class="fas fa-dumbbell"></i></div>
    </div>
  </div>
</template>

<script>
import { mainStorage } from '@/store/main.js'

export default {
  props: ['video'],
  data() {
    return {
      videoInfo: {
        title: '',
        category: '',
        uploadDate: '',
        tools: false,
        length: '',
        difficulty: '',
        thumbnailURL: '',
        vimeoID: '',
        vimeoURL: '',
        newBanner: false
      },
      categoryOptions: mainStorage.state.categoryOptions,
      imgLoaded: false
    }
  },
  methods: {
    processVideoInfo() {
      // Process category
      this.processCategory()

      // Process difficulty
      if (this.video.difficulty === "easy") { this.videoInfo.difficulty = "Fácil"}
      else if (this.video.difficulty === "medium") { this.videoInfo.difficulty = "Intermedio"}
      else if (this.video.difficulty === "hard") { this.videoInfo.difficulty = "Difícil"}

      // Process length
      if (this.video.length) {
        this.videoInfo.length = this.video.length + ' minutos'
      }

      // "New" banner
      let uploadDate = new Date(this.video.uploadDate)
      let now = new Date()
      let difference = (now.getTime() - uploadDate.getTime()) / (1000 * 3600 * 24)
      if (difference < 7) {
        this.videoInfo.newBanner = true
      }

      // Everything else
      this.videoInfo.title = this.video.title
      this.videoInfo.uploadDate = this.video.uploadDate
      this.videoInfo.tools = this.video.tools
      this.videoInfo.thumbnailURL = this.video.thumbnailURL
      this.videoInfo.videoID = this.video.videoID
      this.videoInfo.vimeoURL = this.videoInfo.vimeoURL
    },
    processCategory() {
      this.categoryOptions.forEach((category) => {
        if (this.video.category === category.value) {
          this.videoInfo.category = category.label
        }
      })
    },
    playVideo() {
      this.$emit('playVideo', this.videoInfo.videoID)
    },
    onImgLoad() {
      this.imgLoaded = true
    }
  },
  mounted() {
    this.processVideoInfo()
  }
}
</script>

<style>
.video-card {
  /* max-width: 320px; */
  width: 100%;
  height: auto;
  /* border: solid 1px rgb(173, 173, 173); */
  /* border-radius: 5px; */
  /* box-shadow: 3px 3px rgba(0,0,0,0.2); */
  transition: 0.5s;
  margin: 0px;
}

.video-card:hover {
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.2);
  transform: scale(1.05);
}

.video-card-header {
  position: relative;
  /* max-height: 180px; */
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.video-card-header::after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background-color: #333;
  /* border-top-left-radius: 5px; */
  /* border-top-right-radius: 5px; */
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.3;
  z-index: 0;
}

.video-card-header > * {
  z-index: 10;
}

.video-card-img {
  width: 100%;
  height: 160px;
  /* height: auto; */
  object-fit: cover;
  /* border-top-left-radius: 5px; */
  /* border-top-right-radius: 5px; */
}

.header-pills {
  position: absolute;
  display: flex;
  width: 100%;
  top: 5%;
  left: -3%;
}

.event-pill {
  border-radius: 5px;
  background-color: var(--info);
  color: white;
  font-size: 0.7rem;
  font-weight: bold;
  padding: 0.3rem;
  letter-spacing: 1px;
}

.play-button-wrapper {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 1rem;
  bottom: 35%;
}

.play-button {
  padding: 0.5rem 0.6rem;
  color: white;
  border-radius: 0.2rem;
  background-color: transparent;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  transition: 0.2s;
}

.play-button:hover {
  background-color: rgb(255, 64, 64);
}

.video-card-content {
  position: relative;
  padding: 1rem 1rem 1.5rem 1rem;
}

.top-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 0.8rem;
}

.center-info {
  margin: 0.3rem 0 0 0;
  letter-spacing: 0.6px;
  font-weight: bold;
}

.center-info h3 {
  margin: 0;
}

.bottom-info {
  display: flex;
  flex-direction: row;
  margin: 0.5rem 0 0 0;
  font-size: 0.8rem;
  justify-content: start;
  align-items: center;
}

.pill {
  margin: 0 1rem 1rem 0;
  /* border: solid 1px #333; */
  padding: 0.5rem;
  border-radius: 1rem;
  box-shadow: 0.5px 0.5px #333;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  /* font-size: 0.8rem; */
}

/* Bottom Alternative */
.bottom-info-item {
  margin-right: 1rem;
  text-transform: capitalize;
}

.bottom-info-bells {
  position: absolute;
  font-size: 0.7rem;
  padding: 0.2rem 0.3rem;
  border: solid 1px rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  right: 1rem;
  bottom: 1rem;
}
</style>